import React, { Component, Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import { ButtonActionsTable, StyledButtonActionsTable } from "../../Common/Buttons";
import { hosLocationsTableSchema } from "./schemas/hosLocationsTableSchema";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import CustomForm from "../../../libraries/form";
import _ from "lodash";
import { hosLocationFormSchema } from "./schemas/hosLocationFormSchema";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import permissionCheck from "../../../utils/permissionCheck";

class HosLocationManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddEditLocationForm: false,
      addEditLocationData: {},
      addEditLocationFormState: null,
      selectedLocation: null,
      confirmationDialog: null,
    };

    this.closeDialog = this.closeDialog.bind(this);
    this.openAddLocationForm = this.openAddLocationForm.bind(this);
    this.openEditDeleteRestLocationForm = this.openEditDeleteRestLocationForm.bind(this);
    this.addRestLocation = this.addRestLocation.bind(this);
    this.updateRestLocation = this.updateRestLocation.bind(this);
    this.confirmDeleteRestLocation = this.confirmDeleteRestLocation.bind(this);
  }

  closeDialog() {
    this.setState({ openAddEditLocationForm: false, addEditLocationData: {}, addEditLocationFormState: null, selectedLocation: null });
  }

  openAddLocationForm() {
    this.setState({
      openAddEditLocationForm: true,
      addEditLocationData: {},
      addEditLocationFormState: "create",
    });
  }

  addRestLocation(submission) {
    let { fields } = submission;
    // add new rest location to the server
    const { createLookup, hosLocationsWithAllDetails } = this.context;
    const newLocation = { listName: "hosLocations", ..._.pick(fields, ["description"]) };
    newLocation.opt2 = { ...fields };
    createLookup && createLookup(newLocation, hosLocationsWithAllDetails);

    this.setState({
      selectedLocation: null,
      addEditLocationData: {},
      openAddEditLocationForm: false,
      addEditLocationFormState: null,
    });
  }

  updateRestLocation(submission) {
    let { fields } = submission;
    const { selectedLocation } = this.state;
    const { updateLookup } = this.context;
    const updatedRecord = { ...selectedLocation, ..._.pick(fields, ["description"]) };
    updatedRecord.opt2 = { ...updatedRecord.opt2, ...fields };
    updateLookup && updateLookup(updatedRecord);

    this.setState({
      selectedLocation: null,
      addEditLocationData: {},
      openAddEditLocationForm: false,
      addEditLocationFormState: null,
    });
  }

  openEditDeleteRestLocationForm(originalRow, state) {
    this.setState({
      selectedLocation: originalRow,
      openAddEditLocationForm: true,
      addEditLocationData: {
        description: originalRow.opt2.description,
        city: originalRow.opt2.city,
        state: originalRow.opt2.state,
        division: originalRow.opt2.division,
        subdivision: originalRow.opt2.subdivision,
      },
      addEditLocationFormState: state,
    });
  }

  confirmDeleteRestLocation() {
    const { deleteLookup } = this.context;
    const { selectedLocation } = this.state;
    deleteLookup && deleteLookup(selectedLocation);

    this.setState({
      selectedLocation: null,
      openAddEditLocationForm: false,
      addEditLocationData: {},
      addEditLocationFormState: null,
    });
  }

  render() {
    const adminAccess = permissionCheck("USER", "update");
    const { openAddEditLocationForm, addEditLocationData, addEditLocationFormState } = this.state;
    const { hq } = this.props;
    const { hosLocationsWithAllDetails, hosLocations } = this.context;
    return (
      <div>
        <UISectionHeader
          title={languageService("Browse Rest Locations")}
          // Add Rest Location

          addPermission={adminAccess}
          addButtonTitle={languageService("Add New Rest Location")}
          addCallback={this.openAddLocationForm}
        />
        <ThisTable
          tableColumns={[
            ...hosLocationsTableSchema,
            {
              Header: languageService("Designated Terminal"),
              id: "designatedTerminal",
              accessor: "designatedTerminal",
              Cell: (d) => (d.original.code === this.props.hq ? languageService("Yes") : languageService("No")),
              minWidth: 100,
            },
            {
              Header: languageService("Actions"),
              id: "actions",
              Cell: (d) => {
                const isHq = d.original.code === this.props.hq;
                return (
                  <div>
                    {adminAccess ? (
                      <Fragment>
                        <StyledButtonActionsTable
                          title={languageService("Edit")}
                          onClick={() => this.openEditDeleteRestLocationForm(d.original, "edit")}
                        />
                        {hosLocations && hosLocations.length > 1 && (
                          <StyledButtonActionsTable
                            title={languageService("Delete")}
                            onClick={() => this.openEditDeleteRestLocationForm(d.original, "delete")}
                          />
                        )}
                      </Fragment>
                    ) : null}

                    {isHq ? (
                      <span style={{ fontStyle: "italic", fontWeight: 700 }}>{languageService("HQ")}</span>
                    ) : (
                      <StyledButtonActionsTable title={languageService("Make HQ")} onClick={() => this.props.makeHq(d.original.code)} />
                    )}
                  </div>
                );
              },
              minWidth: 200,
            },
          ]}
          tableData={hosLocationsWithAllDetails}
          pagination={true}
          forDashboard={false}
          height={"auto"}
          onClickSelect
        />
        {openAddEditLocationForm && (
          <CustomForm
            mode="dialog"
            currState={addEditLocationFormState}
            fieldsData={addEditLocationData}
            formSchema={hosLocationFormSchema}
            closeDialog={this.closeDialog}
            parentRef={{
              updateRestLocation: this.updateRestLocation,
              addRestLocation: this.addRestLocation,
              confirmDeleteRestLocation: this.confirmDeleteRestLocation,
            }}
          />
        )}
      </div>
    );
  }
}

HosLocationManager.contextType = FixedAppLookupsContext;

export default HosLocationManager;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosLocationManager/index.jsx